import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Countries from "../pages/countries/page";
import VisaServices from "../pages/visa-services/page";
import ApplyFromHome from "../pages/apply-from-home/page";
import ApplyNow from "../pages/apply-now/page";
import TrackApplication from "../pages/track-application/page";
import DocumentCollection from "../pages/document-collection/page";
import FAQs from "../pages/faqs/page";
import ContactUs from "../pages/contact-us/page";
import AdminLogin from "../pages/admin/login/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminAppointments from "../pages/admin/appointments/page";
import AllApplications from "../pages/admin/applications/page";
import ClientApplicationDetail from "../pages/admin/client-new/page";
import AdminReports from "../pages/admin/reports/page";
import AdminSettings from "../pages/admin/settings/page";
import AdminGuard from "../components/feature/AdminGuard";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/countries", element: <Countries /> },
      { path: "/visa-services", element: <VisaServices /> },
      { path: "/apply-from-home", element: <ApplyFromHome /> },
      { path: "/apply-now", element: <ApplyNow /> },
      { path: "/track-application", element: <TrackApplication /> },
      { path: "/document-collection", element: <DocumentCollection /> },
      { path: "/faqs", element: <FAQs /> },
      { path: "/contact-us", element: <ContactUs /> },
    ],
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminGuard><AdminDashboard /></AdminGuard>,
  },
  {
    path: "/admin/applications",
    element: <AdminGuard><AllApplications /></AdminGuard>,
  },
  {
    path: "/admin/client/:id",
    element: <AdminGuard><ClientApplicationDetail /></AdminGuard>,
  },
  {
    path: "/admin/reports",
    element: <AdminGuard><AdminReports /></AdminGuard>,
  },
  {
    path: "/admin/settings",
    element: <AdminGuard><AdminSettings /></AdminGuard>,
  },
  {
    path: "/admin/appointments",
    element: <AdminGuard><AdminAppointments /></AdminGuard>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;